import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { D3OrgChartNode, Department, Gender, JobTitle, OfficeLocation, Status } from "models/org-chart-node";
import Employee from "models/employee";
import ConsultantFields from "Components/organisms/forms/contractor-form/types";
import Designation from "models/designation";

export interface HumanResourcesSliceState {
    orgChartNodes: D3OrgChartNode[]
    charts: Department[]
    jobTitles: JobTitle[]
    officeLocations: OfficeLocation[]
    genders: Gender[],
    employees: Employee[],
    managers: Employee[],
    departments: Department[],
    status: Status[],
    designations: Designation[],
    consultantFormValues: ConsultantFields
    showSyncModal: boolean,
    isSyncingData: boolean
}

export const initialState: HumanResourcesSliceState = {
    orgChartNodes: [],
    charts: [],
    jobTitles: [],
    officeLocations: [],
    designations: [],
    genders: [],
    employees: [],
    managers: [],
    departments: [],
    status: [],
    consultantFormValues: {} as ConsultantFields,
    showSyncModal: false,
    isSyncingData: false,
};

const humanResourcesSlice = createSlice({
    name: "human-resources",
    initialState,
    reducers: {
        setNodes(state, { payload }: PayloadAction<D3OrgChartNode[]>) {
            state.orgChartNodes = payload
        },
        setCharts(state, { payload }: PayloadAction<Department[]>) {
            state.charts = payload
        },
        setFields(state, { payload }: PayloadAction<{
            jobTitles: JobTitle[],
            officeLocations: OfficeLocation[],
            designations: Designation[]

        }>) {
            state.jobTitles = payload.jobTitles;
            state.officeLocations = payload.officeLocations;
            state.designations = payload.designations
        },
        setConsultantsFormValues(state, { payload }: PayloadAction<{
            jobTitles: JobTitle[]
            officeLocations: OfficeLocation[]
            genders: Gender[],
            employees: Employee[],
            departments: Department[],
            status: Status[]
        }>) {
            state.jobTitles = payload.jobTitles;
            state.departments = payload.departments;
            state.officeLocations = payload.officeLocations;
            state.genders = payload.genders;
            state.employees = payload.employees;
            state.status = payload.status;
        },
        setManagers(state, { payload }: PayloadAction<Employee[]>) {
            state.managers = payload
        },
        setConsultantsFieldValues(state, { payload }: PayloadAction<{
            key: keyof ConsultantFields,
            value: any
        }>) {
            state.consultantFormValues[payload.key] = payload.value
        },
        setShowSyncModal(state, { payload }: PayloadAction<{ show: boolean }>) {
            state.showSyncModal = payload.show
        },
        setIsSyncingData(state, { payload }: PayloadAction<{
            isSyncingData: boolean
        }>) {
            state.isSyncingData = payload.isSyncingData
        },
    },
});

export const {
    setNodes,
    setCharts,
    setFields,
    setConsultantsFormValues,
    setConsultantsFieldValues,
    setIsSyncingData,
    setShowSyncModal,
    setManagers,
} = humanResourcesSlice.actions

export default humanResourcesSlice.reducer;
